export class TranslateTextRequest{
    public text: string = '';
    public from_language: number = 0;
    public to_language: number = 0;
}
